import { useState } from "react";
import { toast } from "react-toastify";

import Modal from "../modal/Modal";
import ToastItem from "../ToastItem";
import { useTicketContext } from "../../context/TicketContext";
import { useNavigate } from "react-router-dom";

const RescanCheckModal = ({ onClose }) => {
  const { rescanCheckRequestHandler, loading } = useTicketContext();
  const [selectedReason, setSelectedReason] = useState(""); // For dropdown
  const [selectedLob, setSelectedLob] = useState(""); // For LOB dropdown when needed
  const [comment, setComment] = useState(""); // Optional comment
  const [isCheckProcessed, setIsCheckProcessed] = useState(false);
  const [error, setError] = useState(""); // State to store errors
  const navigate = useNavigate();

  const handleRemoveError = () => {
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedReason) {
      setError("Please select a reason for rescanning the check.");
      return;
    }

    // Validate LOB selection if the reason is "Change of LOB"
    if (selectedReason === "Change of LOB" && !selectedLob) {
      setError("Please select a LOB.");
      return;
    }

    try {
      // Build payload including LOB if applicable
      const payload = {
        reason: selectedReason,
        comment: comment,
        newLob: selectedLob,

      };

      if (selectedReason === "Change of LOB") {
        payload.lob = selectedLob;
      }

      await rescanCheckRequestHandler("Rescan", payload);
      setIsCheckProcessed(true);
      navigate("/manage-ticket?page=1");
    } catch (error) {
      toast.error(error?.message ? error.message : error + "");
      console.error(error?.message ? error.message : error + "");
    }
  };

  return (
    <Modal
      title={"Rescan the Check"}
      onClose={() => {
        setIsCheckProcessed(false);
        onClose();
      }}
    >
      {isCheckProcessed ? (
        <div className="flex flex-col items-center justify-center h-380 space-y-5">
          <img
            src="/success-fill.svg"
            className="w-104 cursor-pointer"
            alt="success-icon"
          />
          <p className="font-21-31-400-2 w-566 text-center">
            The check rescan request has been processed successfully.
          </p>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="px-4 my-4 py-2 flex relative flex-col space-y-5"
        >
          {loading && (
            <div className="inset-0 absolute w-full h-full bg-white flex items-center justify-center">
              <p className="font-16-21-400">
                Processing your request. Please wait ...
              </p>
            </div>
          )}

          {error && (
            <ToastItem
              item={error}
              index={1}
              onRemove={handleRemoveError}
              type="error"
            />
          )}

          <div className="flex px-2 flex-col my-2">
            <label className="mb-2 font-20-30-400" htmlFor="reason">
              Reason for Rescan
            </label>
            <select
              id="reason"
              value={selectedReason}
              onChange={(e) => {
                setSelectedReason(e.target.value);
                // Clear any previously selected LOB if the reason changes
                if (e.target.value !== "Change of LOB") {
                  setSelectedLob("");
                }
              }}
              className="styled-dropdown"
            >
              <option value="">Select a reason</option>
              <option value="Image quality issue">Image quality issue</option>
              <option value="Missing information">Missing information</option>
              <option value="Incorrect amount">Incorrect amount</option>
              <option value="Change of LOB">Change of LOB</option>
            </select>
          </div>

          {selectedReason === "Change of LOB" && (
            <div className="flex px-2 flex-col my-2">
              <label className="mb-2 font-20-30-400" htmlFor="lob">
                Select LOB
              </label>
              <select
                id="lob"
                value={selectedLob}
                onChange={(e) => setSelectedLob(e.target.value)}
                className="styled-dropdown"
              >
                <option value="">Select a LOB</option>
                <option value="Retail">Retail</option>
                <option value="DentalClaims">DentalClaims</option>
                <option value="DIFieldLicensing">DIFieldLicensing</option>
                <option value="ILNB">ILNB</option>
                <option value="DIMultiLife">DIMultiLife</option>
                <option value="DentalNetwork">DentalNetwork</option>
              </select>
            </div>
          )}

          <div className="flex px-2 flex-col my-2">
            <label className="mb-2 font-20-30-400" htmlFor="comment">
              Comment (Optional)
            </label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="border-2 p-2"
              placeholder="Add any additional comments (optional)"
            />
          </div>

          {/** Submit and Cancel Buttons */}
          <div className="flex space-x-4">
            <div className="py-2 w-135">
              <button
                type="submit"
                className="border-none w-full h-49 font-16-21-700 capitalize justify-center rounded-md bg-[#3C394D] px-8 text-sm text-white shadow-sm sm:w-auto"
              >
                Submit
              </button>
            </div>

            <div className="py-2 w-135">
              <button
                type="button"
                onClick={() => onClose(false)}
                className="border-none w-full h-49 font-16-21-700 capitalize justify-center rounded-md bg-cancel-2 px-8 text-sm text-white sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default RescanCheckModal;
